import { Component, EventEmitter, Input, Output } from '@angular/core';
import { ConfirmationService, MessageService } from 'primeng/api';

@Component({
  selector: 'app-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  providers: [ConfirmationService, MessageService],
})
export class ConfirmDialogComponent {
  @Input() title: string = '';
  @Input() open: boolean = false;
  @Input() cancelButtonLabel: string = 'Cancel';
  @Input() confirmButtonLabel: string = 'Confirm';

  @Output() onCancel = new EventEmitter();
  @Output() onConfirm = new EventEmitter();

  onCancelClick(event: MouseEvent) {
    this.onCancel.emit(event);
  }

  onConfirmationClick(event: MouseEvent) {
    this.onConfirm.emit(event);
  }
}
